export enum ChallengeReason {
    REQUIRED = 'Required',
    UNKNOWN_DEVICE = 'UnknownDevice',
    TERMS_UPDATE = 'TermsUpdate',
    EXPIRED = 'Expired',
    EXPIRES = 'Expires',
}
